module.exports = __webpack_public_path__ + "static/media/visa.22be16c1.svg";